import React, { useState } from "react";
import Classes from "./Join.module.css";
import { BulbIcon, StarIcon, TickIcon } from "../../../utils/Icons";
import { AnimatePresence, motion, easeOut } from "framer-motion";
import { useNavigate } from "react-router-dom";

/* ───────── framer-motion variants ───────── */
const container = {
    hidden: { opacity: 0, y: 24 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.45, ease: easeOut, staggerChildren: 0.15 },
    },
};

const item = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.35, ease: easeOut } },
};

export default function Join() {
    const [activeOption, setActiveOption] = useState(null);
    const navigateTo = useNavigate();

    return (
        <div className={Classes.hero}>
            {/* ───────── static header (no animation) ───────── */}
            <div className={Classes.header}>
                <div>
                    <h3>Mentor</h3>
                </div>
                <div>
                    <h5 onClick={() => navigateTo("/")}>Go back to Mentr</h5>
                </div>
            </div>

            {/* ───────── animated body ───────── */}
            <div className={Classes.body}>
                <motion.div
                    className={Classes.bodyInner}
                    variants={container}
                    initial="hidden"
                    animate="visible"
                >
                    {/* headline & sub-copy */}
                    <motion.h3 variants={item}>
                        How would you like to use Mentr?
                    </motion.h3>

                    <motion.h5 variants={item}>
                        Choose your role to get a personalized experience. Whether you're
                        here to share your expertise or find guidance, Mentr is built to
                        help you connect with the right people.
                    </motion.h5>

                    {/* role options */}
                    <motion.div className={Classes.options} variants={container}>
                        {/* ── option: Mentor ── */}
                        <motion.div className={Classes.optionItem} variants={item}>
                            <div
                                className={Classes.optionIcon}
                                style={{
                                    borderColor: activeOption === "mentor" ? "#F26A63" : "",
                                }}
                                onClick={() => setActiveOption("mentor")}
                            >
                                <StarIcon
                                    width={50}
                                    height={50}
                                    fill={activeOption === "mentor" ? "#F26A63" : "#5C5C5C"}
                                />

                                {/* tick animation */}
                                <AnimatePresence>
                                    {activeOption === "mentor" && (
                                        <motion.div
                                            initial={{ opacity: 0, scale: 0 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0 }}
                                            transition={{ duration: 0.2, ease: easeOut }}
                                            className={Classes.tick}
                                        >
                                            <TickIcon fill="white" />
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                            <h4>Mentor</h4>
                            <h5>
                                Mentor and earn—set your rate, <br /> link your calendar, and
                                get booked.
                            </h5>
                        </motion.div>

                        {/* ── option: Mentee ── */}
                        <motion.div className={Classes.optionItem} variants={item}>
                            <div
                                className={Classes.optionIcon}
                                style={{
                                    borderColor: activeOption === "mentee" ? "#F26A63" : "",
                                }}
                                onClick={() => setActiveOption("mentee")}
                            >
                                <BulbIcon
                                    width={50}
                                    height={50}
                                    fill={activeOption === "mentee" ? "#F26A63" : "#5C5C5C"}
                                />

                                {/* tick animation */}
                                <AnimatePresence>
                                    {activeOption === "mentee" && (
                                        <motion.div
                                            initial={{ opacity: 0, scale: 0 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0 }}
                                            transition={{ duration: 0.2, ease: easeOut }}
                                            className={Classes.tick}
                                        >
                                            <TickIcon fill="white" />
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                            <h4>Mentee</h4>
                            <h5>
                                Join Mentr to connect with <br /> experts and book 1-on-1
                                guidance.
                            </h5>
                        </motion.div>
                    </motion.div>

                    {/* continue button */}
                    <motion.button
                        className={Classes.joinButton}
                        variants={item}
                        onClick={() => navigateTo(`/join/${activeOption}`)}
                        disabled={!activeOption}
                    >
                        <h5>Choose one to continue</h5>
                    </motion.button>
                </motion.div>
            </div>
        </div>
    );
}
